import { render, staticRenderFns } from "./SealingTasks.vue?vue&type=template&id=f9c340e4&scoped=true&"
import script from "./SealingTasks.vue?vue&type=script&lang=js&"
export * from "./SealingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c340e4",
  null
  
)

export default component.exports